import "../../chunk-5WRI5ZAA.js";

// src/visualBuilder/utils/createCachedFetch.ts
function createCachedFetch(fetchFn) {
  let uidResolver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return JSON.stringify(args);
  };
  const cache = /* @__PURE__ */new Map();
  const pendingPromises = /* @__PURE__ */new Map();
  async function cachedFetch() {
    const uid = uidResolver(...arguments);
    if (cache.has(uid)) {
      return cache.get(uid);
    }
    if (pendingPromises.has(uid)) {
      return pendingPromises.get(uid);
    }
    const promise = fetchFn(...arguments).then(data => {
      cache.set(uid, data);
      pendingPromises.delete(uid);
      return data;
    }).catch(error => {
      pendingPromises.delete(uid);
      throw error;
    });
    pendingPromises.set(uid, promise);
    return promise;
  }
  cachedFetch.clearCache = () => {
    cache.clear();
    pendingPromises.clear();
  };
  return cachedFetch;
}
export { createCachedFetch };